


























import Vue from 'vue'
import Component from 'vue-class-component';
import api, { IResult } from "@/ts/functions";
import { IDataVueModel } from "@/ts/models/IDataVueModel";

@Component
export default class ThankYou extends Vue {
    name: string = 'ThankYouNoFee';
    isLoading: boolean = true;
    applicationNumber: any = null; 
    formName: any = null;
    mounted() {
        this.formName = this.$route.params.formType;
        this.applicationNumber = this.$route.params.applicationNumber;
    }
}
